import React,{useEffect, useState} from 'react'



import { TextInput } from '../../components/input'
import { LogInService } from '../../services/AuthServices';
import { useDispatch } from 'react-redux';
import { LogInAction, LogOutAction } from '../../redux/actions/authAction';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-hot-toast';
import {AiFillEye,AiFillEyeInvisible} from 'react-icons/ai';
import lawimg from '../../images/law_banner.webp'

function Login() {

    const [data,setdata] = useState({user_id:'',password:''});
    const [error,seterror] = useState({user_id:'',password:''});

    const [visible,setvisible] = useState(false)

    
    const dispatch = useDispatch();
    const navigate = useNavigate();



    useEffect(()=>{  
        dispatch(LogOutAction())
    },[])


    function handlechange(e){
        setdata({...data,[e.target.name] : e.target.value})
        seterror({...error,[e.target.name]:''})
    }

    function onKeyDownHandler(e){
       
        if (e.keyCode === 13) {
            submitform();
        }
    }

    async function submitform(){

        if(!data.user_id){
            toast.error('Mobile No is required')
            seterror({...error,user_id:'Mobile No is required'})
        }else if(!data.password){
            toast.error('Password field is required')
            seterror({...error,password:'Password field is required'})
        }else{
            const response = await LogInService(data)
            console.log("response?.data",response?.data)
            if(response.status === 200){
      
                dispatch(LogInAction(response.data))
                if(response?.data?.app_access){
                    navigate('/dashboard')
                }else{
                    toast.error("You don't have any access to this application")
                }
            }else if(response.status === 401){
                toast.error(response.data.errors)
                seterror({...error,password:response.data.errors})
            }
        }
    }

  return (

   

    <div className='flex w-screen overflow-y-hidden items-center h-screen min-h-screen max-h-screen justify-center md:justify-between'>

     <div className='hidden md:block min-w-[70vw] h-screen w-[70vw] max-w-[70vw] bg-[#1b3f69]'>
        <img src={lawimg} className='w-full h-full object-cover opacity-30' />
    </div>   


    <div className='min-w-[70vw] w-[70vw] max-w-[70vw]  md:min-w-[30vw] md:w-[30vw] md:max-w-[30vw] flex justify-center items-center' >

         <div className=''>
            <div className='p-1 w-72'  >  

            <h6 className='text-[18px] font-[800]'>Sign In</h6>      
            <h6 className={`text-[10px] font-[400] leading-normal mb-4 my-2`}>Add your official phone and password to access all the features provided to you.</h6>
            
            <form
             onKeyDown={onKeyDownHandler}
             onSubmit={submitform}
            > 
            <TextInput 
                label={'Mobile No'}  
                variant="standard"
                name="user_id"
                type="text"
                value={data.user_id}
                handlechange={handlechange}
                placeholder="Enter your mobile no"
                InputLabelProps={{
                    style: { color: '#fff', }, 
                }}/>


            <div className='relative'>
            <TextInput 
                label={'Password'}  
                variant="standard"
                name="password"
                type={visible ? "text" : "password"}
                // error={error.password}
                value={data.password}
                handlechange={handlechange}
                placeholder="Enter your password"
                InputLabelProps={{
                    style: { color: '#fff', }, 
                }}/>  
               {visible ?  <AiFillEye className='absolute right-1 top-[24px] cursor-pointer text-slate-200 ' onClick={()=>setvisible(!visible)} /> : <AiFillEyeInvisible className='absolute right-1 top-[24px] cursor-pointer text-slate-200 ' onClick={()=>setvisible(!visible)} />}
            </div>



                <h6 onClick={submitform} className="bg-slate-900 text-white cursor-pointer text-center mt-4  font-[500] py-[8px] px-4 mt-0  w-full rounded-md border-slate-900  text-[14px] hover:border-slate-900">SIGN IN</h6>
            </form>

            <h6 className='text-[10px] mt-4 text-800 leading-normal'>By continuing, you agree to Fidelitus<span className='text-black font-bold text-[#0a69da]'> Conditions of Use</span>  and <span className='text-black font-bold text-[#0a69da]'> Privacy Notice </span> .</h6>


            <h6 onClick={()=>navigate('/forgot_password')}  className="w-full  py-2 px-4 mt-5 rounded text-center  text-[12px] cursor-pointer">Forgot Password</h6>

            </div>
        </div>  
    </div> 

  
    </div>    


      
  )
}

export default Login